import { AccountSearchDto } from '../../../proto/accounts';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { ReservationContactDto } from '../../../shared/modules/contacts/dtos/reservation-contact.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { PricingItemDto } from '../../../shared/modules/pricing-items/dtos/pricing-item.dto';
import { ComputedPeriodDurationDto } from '../../../shared/modules/shared/dtos/computed-period-duration.dto';
import { AgentSearchDto } from '../../agents';
import { RentalReservationBookerContactDto } from './rental-reservation-booker-contact.dto';
import { LocationRecordDto } from '../../locations/dtos/location-record.dto';
import { PolicyAssignDto } from '../../policies/dtos/policy-assign.dto';
import {
  RentalAgreementSearchDto,
  RentalPartySourceTypeEnum,
} from '../../rental-agreements';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleCategorySearchDto } from '../../vehicle-categories';
import { VehicleSearchDto } from '../../vehicles';
import { RentalReservationRecordCategoryEnum } from '../enums/rental-reservation-record-category.enum';
import { RentalReservationStatusEnum } from '../enums/rental-reservation-status.enum';

import { RentalReservationLinksDto } from './rental-reservation-links.dto';

/**
 * The reservation a client reads back. `bookerContact` is the matched
 * customer while the guest is pending, and the stored party otherwise.
 */
@CaslSubject(AppSubjectEnum.RENTAL_RESERVATION)
export class RentalReservationRecordDto extends BaseDto {
  code!: string;
  externalReference?: string | null;
  qrCode?: string | null;
  status!: RentalReservationStatusEnum;
  notes?: string | null;
  recordCategory!: RentalReservationRecordCategoryEnum;
  reservationContact?: ReservationContactDto | null;
  bookerContact?: RentalReservationBookerContactDto | null;
  partyType?: RentalPartySourceTypeEnum | null;
  accountUuid?: string | null;
  account?: AccountSearchDto | null;
  pickupLocation?: LocationRecordDto | null;
  dropOffLocation?: LocationRecordDto | null;
  startsAt!: Date;
  endsAt!: Date;
  vehicleId?: number | null;
  vehicle?: VehicleSearchDto | null;
  vehicleCategoryId?: number | null;
  vehicleCategory?: VehicleCategorySearchDto | null;
  pickupLocationId?: number | null;
  dropOffLocationId?: number | null;
  agentId?: number | null;
  agent?: AgentSearchDto | null;
  rentalAgreementId?: number | null;
  rentalAgreement?: RentalAgreementSearchDto | null;
  pricingItems?: PricingItemDto[] | null;
  computedPeriod?: ComputedPeriodDurationDto | null;
  computedTotalNet?: number | null;
  computedTotalTax?: number | null;
  computedTotalGross?: number | null;
  computedDiscountNet?: number | null;
  computedDiscountTax?: number | null;
  computedDiscountGross?: number | null;
  computedStandardNet?: number | null;
  computedStandardTax?: number | null;
  computedStandardGross?: number | null;
  computedExtrasNet?: number | null;
  computedExtrasTax?: number | null;
  computedExtrasGross?: number | null;
  /**
   * Broker display-only. Populated by search-cache and quote flows; not used
   * by manage manage pricing apply / hydration.
   */
  computedSavingsAmount?: number | null;
  /**
   * Broker display-only. Populated by search-cache and quote flows; not used
   * by manage manage pricing apply / hydration.
   */
  computedSavingsPercentage?: number | null;
  /**
   * Broker display-only. Populated by search-cache and quote flows; not used
   * by manage manage pricing apply / hydration.
   */
  computedOriginalStandardAmount?: number | null;
  computedCommissionNet?: number | null;
  computedPeriodSort?: number | null;
  tags?: TagListDto[] | null;
  policies?: PolicyAssignDto[] | null;
  links?: RentalReservationLinksDto | null;
  files?: FileDto[] | null;
}
